const GOOGLE_ACCOUNTS_LIB = 'https://accounts.google.com/gsi/client';

export default GOOGLE_ACCOUNTS_LIB;
